/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TaxRate } from './';
import {
    TaxRateFromJSON,
    TaxRateFromJSONTyped,
    TaxRateToJSON,
} from './';
import type { TaxRateWithAmount } from './';
import {
    TaxRateWithAmountFromJSON,
    TaxRateWithAmountFromJSONTyped,
    TaxRateWithAmountToJSON,
} from './';

/**
 * 
 * @export
 * @interface ActivityReportEstimatedEarningsResource
 */
export interface ActivityReportEstimatedEarningsResource {
    /**
     * 
     * @type {number}
     * @memberof ActivityReportEstimatedEarningsResource
     */
    amountExcludingServiceFeesIncludingTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityReportEstimatedEarningsResource
     */
    freelanceFeesExcludingTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityReportEstimatedEarningsResource
     */
    freelanceFeesIncludingTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityReportEstimatedEarningsResource
     */
    freelanceFeesTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityReportEstimatedEarningsResource
     */
    totalAmountExcludingTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityReportEstimatedEarningsResource
     */
    totalAmountIncludingTaxes: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityReportEstimatedEarningsResource
     */
    totalAmountTaxes: number;
    /**
     * 
     * @type {string}
     * @memberof ActivityReportEstimatedEarningsResource
     */
    currencyCode: string;
    /**
     * 
     * @type {number}
     * @memberof ActivityReportEstimatedEarningsResource
     */
    freelancerFeesPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityReportEstimatedEarningsResource
     */
    freelancerDailyRate: number;
    /**
     * 
     * @type {string}
     * @memberof ActivityReportEstimatedEarningsResource
     */
    freelancerCurrencyCode?: string;
    /**
     * 
     * @type {number}
     * @memberof ActivityReportEstimatedEarningsResource
     */
    totalAmountInFreelancerCurrency?: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityReportEstimatedEarningsResource
     */
    estimationExchangeRate?: number;
    /**
     * 
     * @type {Array<TaxRate>}
     * @memberof ActivityReportEstimatedEarningsResource
     */
    taxes: Array<TaxRate>;
    /**
     * 
     * @type {Array<TaxRateWithAmount>}
     * @memberof ActivityReportEstimatedEarningsResource
     */
    taxesWithAmount: Array<TaxRateWithAmount>;
    /**
     * decimal rate like 0.20
     * @type {number}
     * @memberof ActivityReportEstimatedEarningsResource
     */
    freelancerFeeTaxRate: number;
}

/**
 * Check if a given object implements the ActivityReportEstimatedEarningsResource interface.
 */
export function instanceOfActivityReportEstimatedEarningsResource(value: object): value is ActivityReportEstimatedEarningsResource {
    if (!('amountExcludingServiceFeesIncludingTaxes' in value) || value['amountExcludingServiceFeesIncludingTaxes'] === undefined) return false;
    if (!('freelanceFeesExcludingTaxes' in value) || value['freelanceFeesExcludingTaxes'] === undefined) return false;
    if (!('freelanceFeesIncludingTaxes' in value) || value['freelanceFeesIncludingTaxes'] === undefined) return false;
    if (!('freelanceFeesTaxes' in value) || value['freelanceFeesTaxes'] === undefined) return false;
    if (!('totalAmountExcludingTaxes' in value) || value['totalAmountExcludingTaxes'] === undefined) return false;
    if (!('totalAmountIncludingTaxes' in value) || value['totalAmountIncludingTaxes'] === undefined) return false;
    if (!('totalAmountTaxes' in value) || value['totalAmountTaxes'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('freelancerFeesPercentage' in value) || value['freelancerFeesPercentage'] === undefined) return false;
    if (!('freelancerDailyRate' in value) || value['freelancerDailyRate'] === undefined) return false;
    if (!('taxes' in value) || value['taxes'] === undefined) return false;
    if (!('taxesWithAmount' in value) || value['taxesWithAmount'] === undefined) return false;
    if (!('freelancerFeeTaxRate' in value) || value['freelancerFeeTaxRate'] === undefined) return false;
    return true;
}

export function ActivityReportEstimatedEarningsResourceFromJSON(json: any): ActivityReportEstimatedEarningsResource {
    return ActivityReportEstimatedEarningsResourceFromJSONTyped(json, false);
}

export function ActivityReportEstimatedEarningsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityReportEstimatedEarningsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'amountExcludingServiceFeesIncludingTaxes': json['amountExcludingServiceFeesIncludingTaxes'],
        'freelanceFeesExcludingTaxes': json['freelanceFeesExcludingTaxes'],
        'freelanceFeesIncludingTaxes': json['freelanceFeesIncludingTaxes'],
        'freelanceFeesTaxes': json['freelanceFeesTaxes'],
        'totalAmountExcludingTaxes': json['totalAmountExcludingTaxes'],
        'totalAmountIncludingTaxes': json['totalAmountIncludingTaxes'],
        'totalAmountTaxes': json['totalAmountTaxes'],
        'currencyCode': json['currencyCode'],
        'freelancerFeesPercentage': json['freelancerFeesPercentage'],
        'freelancerDailyRate': json['freelancerDailyRate'],
        'freelancerCurrencyCode': json['freelancerCurrencyCode'] == null ? undefined : json['freelancerCurrencyCode'],
        'totalAmountInFreelancerCurrency': json['totalAmountInFreelancerCurrency'] == null ? undefined : json['totalAmountInFreelancerCurrency'],
        'estimationExchangeRate': json['estimationExchangeRate'] == null ? undefined : json['estimationExchangeRate'],
        'taxes': ((json['taxes'] as Array<any>).map(TaxRateFromJSON)),
        'taxesWithAmount': ((json['taxesWithAmount'] as Array<any>).map(TaxRateWithAmountFromJSON)),
        'freelancerFeeTaxRate': json['freelancerFeeTaxRate'],
    };
}

export function ActivityReportEstimatedEarningsResourceToJSON(value?: ActivityReportEstimatedEarningsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amountExcludingServiceFeesIncludingTaxes': value['amountExcludingServiceFeesIncludingTaxes'],
        'freelanceFeesExcludingTaxes': value['freelanceFeesExcludingTaxes'],
        'freelanceFeesIncludingTaxes': value['freelanceFeesIncludingTaxes'],
        'freelanceFeesTaxes': value['freelanceFeesTaxes'],
        'totalAmountExcludingTaxes': value['totalAmountExcludingTaxes'],
        'totalAmountIncludingTaxes': value['totalAmountIncludingTaxes'],
        'totalAmountTaxes': value['totalAmountTaxes'],
        'currencyCode': value['currencyCode'],
        'freelancerFeesPercentage': value['freelancerFeesPercentage'],
        'freelancerDailyRate': value['freelancerDailyRate'],
        'freelancerCurrencyCode': value['freelancerCurrencyCode'],
        'totalAmountInFreelancerCurrency': value['totalAmountInFreelancerCurrency'],
        'estimationExchangeRate': value['estimationExchangeRate'],
        'taxes': ((value['taxes'] as Array<any>).map((v) => TaxRateToJSON(v))),
        'taxesWithAmount': ((value['taxesWithAmount'] as Array<any>).map((v) => TaxRateWithAmountToJSON(v))),
        'freelancerFeeTaxRate': value['freelancerFeeTaxRate'],
    };
}

